import React from 'react';

import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagemProps, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { GrupoExibicaoProps } from 'pages/cadastro/loja/types';

export type GrupoExibicaoRequestResult = RequestListagemProps & {
    data: GrupoExibicaoProps[];
};

export function useGetGrupoExibicao(): UseQueryResult<GrupoExibicaoRequestResult> {
    const { sort, page, filter, limit } = useListagemContext();

    const requestListagem = useRequestListagem();

    const requestGrupoExibicaoOptions: RequestOptionsType = {
        url: 'gestao/configuracaopropriedadegrupoexibicao',
        sort: [{ property: 'nrSequencia', direction: 'ASC' }],
        filter,
        page,
        limit: 30,
    };

    return useQuery<GrupoExibicaoRequestResult>([requestGrupoExibicaoOptions], () =>
        requestListagem(requestGrupoExibicaoOptions).then((res) => res.data),
    );
}
